/**
 * Shared presentation config for corporate events extracted from Sbírka
 * listin documents (`CorporateEventType`) — used by the /historie timeline,
 * the "Firemní události" teaser card on Přehled and the dashboard feed.
 */
import {
	ArrowRightLeft,
	Ban,
	Banknote,
	Building2,
	FileSignature,
	GitBranch,
	GitMerge,
	Landmark,
	MapPin,
	RefreshCw,
	Scale,
	Sparkles,
	Tag,
	TrendingDown,
	TrendingUp,
	Users,
} from "lucide-react";

export interface CorporateEventConfig {
	label: string;
	icon: typeof GitMerge;
	iconClasses: string;
}

export const CORPORATE_EVENT_CONFIG: Record<string, CorporateEventConfig> = {
	MERGER: {
		label: "Fúze",
		icon: GitMerge,
		iconClasses: "bg-accent-50 text-accent-600",
	},
	DEMERGER: {
		label: "Rozdělení společnosti",
		icon: GitBranch,
		iconClasses: "bg-accent-50 text-accent-600",
	},
	TRANSFORMATION: {
		label: "Přeměna společnosti",
		icon: RefreshCw,
		iconClasses: "bg-accent-50 text-accent-600",
	},
	CAPITAL_INCREASE: {
		label: "Zvýšení základního kapitálu",
		icon: TrendingUp,
		iconClasses: "bg-green-50 text-green-600",
	},
	CAPITAL_DECREASE: {
		label: "Snížení základního kapitálu",
		icon: TrendingDown,
		iconClasses: "bg-red-50 text-red-600",
	},
	ARTICLES_AMENDMENT: {
		label: "Změna zakladatelských dokumentů",
		icon: FileSignature,
		iconClasses: "bg-primary-50 text-primary-600",
	},
	DISSOLUTION: {
		label: "Zrušení společnosti",
		icon: Ban,
		iconClasses: "bg-red-50 text-red-600",
	},
	LIQUIDATION: {
		label: "Likvidace",
		icon: Scale,
		iconClasses: "bg-red-50 text-red-600",
	},
	LEGAL_FORM_CHANGE: {
		label: "Změna právní formy",
		icon: Building2,
		iconClasses: "bg-accent-50 text-accent-600",
	},
	OWNERSHIP_TRANSFER: {
		label: "Převod podílu",
		icon: ArrowRightLeft,
		iconClasses: "bg-primary-50 text-primary-600",
	},
	BOARD_CHANGE: {
		label: "Změna orgánů společnosti",
		icon: Users,
		iconClasses: "bg-primary-50 text-primary-600",
	},
	PROFIT_DISTRIBUTION: {
		label: "Rozdělení zisku",
		icon: Banknote,
		iconClasses: "bg-green-50 text-green-600",
	},
	SEAT_CHANGE: {
		label: "Změna sídla",
		icon: MapPin,
		iconClasses: "bg-primary-50 text-primary-600",
	},
	NAME_CHANGE: {
		label: "Změna názvu",
		icon: Tag,
		iconClasses: "bg-primary-50 text-primary-600",
	},
	FOUNDING: {
		label: "Založení společnosti",
		icon: Sparkles,
		iconClasses: "bg-green-50 text-green-600",
	},
	OTHER: {
		label: "Korporátní událost",
		icon: Landmark,
		iconClasses: "bg-gray-100 text-gray-600",
	},
};

export const FALLBACK_CORPORATE_EVENT_CONFIG: CorporateEventConfig = {
	label: "Korporátní událost",
	icon: Landmark,
	iconClasses: "bg-gray-100 text-gray-600",
};

export function corporateEventConfig(eventType: string): CorporateEventConfig {
	return CORPORATE_EVENT_CONFIG[eventType] ?? FALLBACK_CORPORATE_EVENT_CONFIG;
}
